import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { LabelValue } from 'app/models/LabeLValue';

declare let jQuery;

@Component({
  template: '',
  styleUrls: []
})
export abstract class InsightsSectionComponent implements OnInit {
  @Input() appId: string;
  @Input() appName: string;
  @Input() data: any; // TODO: must update to proper types
  @Input() type: string;
  @Input() os: string;
  @Input() device: string;
  @Input() region: string;
  @Input() month: string;
  @Input() numWatching: number;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;
  @Input() isAnonymous: boolean;
  @Input() processingFollow: boolean;
  @Input() selectedCountry: LabelValue;
  @Input() processing: boolean;
  @Input() includeAppSpoofing: boolean;
  @Input() sectionTitle: string;
  @Input() swiperControls: TemplateRef<any>;

  @Output() toAppDiscovery: EventEmitter<any> = new EventEmitter<any>();
  @Output() followButtonBreakpointReached: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() followButtonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() anchorClick = new EventEmitter<string>();

  @ViewChild('widgetHeader') headerElement: ElementRef;

  currentTop: number;
  isTop: boolean;

  protected constructor(public _changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {
    setTimeout(fn => {
      jQuery('[data-toggle="tooltip"]').tooltip({ animation: false });
    }, 100);
  }

  // @HostListener('window:scroll', ['$event'])
  // handleScroll(event: Event) {
  //   if (this.headerElement && this.headerElement.nativeElement) {
  //     const bounds = this.headerElement.nativeElement.getBoundingClientRect();
  //     if (bounds.top <= 0) {
  //       this.isTop = true;
  //     } else {
  //       this.isTop = false;
  //     }
  //   }
  // }
}
